import { useQuery } from "@tanstack/react-query";

import { fetchUsersVotingPower } from "services/marinade/fetchUsersVotingPower";

const refetchInterval = 60 * 60 * 1000;
const staleTime = 60 * 60 * 1000;

export const useUsersVotingPower = (address?: string) => {
  return useQuery(
    ["directed-stake-mnde-votes", address],
    () => (address ? fetchUsersVotingPower(address) : null),
    {
      refetchInterval,
      staleTime,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );
};
